import styled from 'styled-components';

const AppBlock = styled.section`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 16px;
  padding-bottom: 24px;
`;

export default AppBlock;
